import { createSelector } from "reselect";

import { RootState } from "redux/reducers/rootReducer";

import { CountryCode } from "../../custom-types/Finder";

const getConfigState = (state: RootState) => state.config;

export const getSignInUrlWithoutReturnUrl = createSelector(
  [getConfigState],
  (state) => state.sso?.signInUrlWithoutReturnUrl
);
export const getSignUpUrlWithoutReturnUrl = createSelector(
  [getConfigState],
  (state) => state.sso?.signUpUrlWithoutReturnUrl
);
export const getSignOutUrlWithoutReturnUrl = createSelector(
  [getConfigState],
  (state) => state.sso?.signOutUrlWithoutReturnUrl
);
export const getDomainCountryCode = createSelector(
  [getConfigState],
  (state) => state.domainCountryCode as CountryCode
);
